import { ImagePath } from "../../../assets/ImagePath";
import { Button } from "../../../components/ui/button";
import { useEffect, useState } from "react";
import OtpInputComponent from "../../../components/ui/OtpInput";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { appType, getCurrentAuthCode } from "../../../utils/config/configHelpers";
import { showToast } from "../../../components/ui/toaster";
import { UserServiceClientApi } from "../../../services/api/UserApiServices";
import authFunctions from "../../../services/userApiServices/authFunctions";
import { storeAuthData } from "../../../services/storage/LocalStorage";
import { useDispatch } from "react-redux";
import { setSessionIdInAxios } from "../../../services/userApiServices/axiosInstance";
import { fetchWalletBalanceService, setLoggedUserDetails } from "../../../state/actions/user";
import { setBotWaitLoader } from "../../../state/actions/loader";
import { setInializeSocket } from "../../../state/actions/socket";
import { setClearCacheForSpinnetBot } from "../../../state/actions/bot";
import { getUserDomainList, setDomainState } from "../../../state/actions/domain";
import LoadingModal from "../../../components/ui/Loader/LoadingModal";
import { activateEnterpriseBots } from "../../../services/api/BotApiServices";
import { loadAllDomainsListInLFStorage } from "../../../services/storage/LFStorage";
import { FRONTM_DOMAIN } from "../../../utils/constants";
import { Label } from "../../../components/ui/label";
import { Input } from "../../../components/ui/input";
import { Card } from "../../../components/ui/card";
import { passwordErrorMessage, passwordRegex } from "../../../utils/Validator";
import { getDomainConfig } from "../../../utils/DomainsHelper";
import webSocketApiService from "../../../services/socket/wsApiServices";
import { styled } from "@mui/material";


const OtpVerify = ({ email, forgotPasswordOtp }) => {
	const location = useLocation();
	const userData = location.state;
	const emailN = email || location.state?.email;
	const navigate = useNavigate();
	const dispatch = useDispatch()

	const [otp, setOtp] = useState("");
	const [isLoading, setIsLoading] = useState(false);
	const [password, setPassword] = useState("");
	const [otpError, setOtpError] = useState("");
	const [passwordError, setPasswordError] = useState("");
	const [resendLoading, setResendLoading] = useState(false);
	const [showPassword, setShowPassword] = useState(false);
	const [logoImage, setLogoImage] = useState("");
	const [showToolTip, setShowToolTip] = useState(false);
	const [passwordCriteria, setPasswordCriteria] = useState([
		{ text: " One uppercase letter", isDone: false },
		{ text: " One lowercase letter", isDone: false },
		{ text: " One special character", isDone: false },
		{ text: " One number", isDone: false },
		{ text: " 8 characters minimum", isDone: false },
	]);

	const CustomToolTip = styled('div')({
		zIndex: 9999999,
		position: 'absolute',
		backgroundColor: '#fff',
		borderRadius: '6px',
		padding: '20px',
		bottom:'65px',
		boxShadow: '0 0 6px 0 rgba(42,45,60,0.4)',
	});

	const handleChange = (e) => {
		const value = e.target.value;
		setPassword(value);

		if (passwordRegex.test(value)) {
			setPasswordError('');
		}
		passwordChecking(value);
	};

	const passwordChecking = (string) => {
		const newArr = [...passwordCriteria];
		if (string.length >= 8) {
			newArr[4].isDone = true;
		} else {
			newArr[4].isDone = false;
		}
		newArr[1].isDone = /[a-z]/.test(string);
		newArr[0].isDone = /[A-Z]/.test(string);
		newArr[3].isDone = /[0-9]/.test(string);
		newArr[2].isDone = /[\^$*.[\]{}()?"!'@#%&\\/,><:;|_~`]/.test(string);
		setPasswordCriteria(newArr);
	};

	const handleOtpChange = (e) => {
		if (e.length === 6) {
			setOtpError('');
		}
		setOtp(() => {
			const newOtp = e;
			return newOtp;
		});
	};

	const handleVerifyCode = async () => {
		let valid = true;

		// Reset previous errors
		setOtpError("");
		setPasswordError("");

		// Validate OTP
		if (otp?.trim().length !== 6) {
			setOtpError("OTP must be 6 digits.");
			valid = false;
		}

		// Validate Password only if in Forgot Password flow
		if (forgotPasswordOtp) {
			if (password && password.trim() === "") {
				setPasswordError("Password is required.");
				valid = false;
			} else if (!passwordRegex.test(password)) {
				setPasswordError(passwordErrorMessage);
				valid = false;
			}
		}

		if (!valid) return;

		// FORGOT PASSWORD FLOW
		if (forgotPasswordOtp) {
			const params = {
				email: emailN,
				verificationCode: otp,
				newPassword: password,
				appType,
			};

			setIsLoading(true);
			try {
				const response = await UserServiceClientApi.confirmPassword(params);
				
				if (response?.payload && response?.payload?.success) {
					showToast("success", response?.payload?.message);
					navigate("/login", { replace: true });
				} else {
					showToast("error", response?.error || "Password reset failed.");
				}
			} catch (error) {
				showToast("error", error.message || "An error occurred.");
			} finally {
				setIsLoading(false);
			}
			return;
		}

		// NORMAL SIGNUP OTP VERIFICATION FLOW
		const doConfirmSignUpObj = {
			email: emailN,
			password: userData.password,
			confirmCode: otp,
			appType,
		};

		setIsLoading(true);
		UserServiceClientApi.verifyOtp(doConfirmSignUpObj).then(async (res) => {
			if (res?.payload && res?.payload?.success) {
				let response = await authFunctions.loginUser(userData.email, userData.password, appType);
				setIsLoading(false);
				if (response && response?.payload && response?.payload?.success) {
					const { user, sessionId, refreshToken, accessToken } = response.payload;
					setSessionIdInAxios(sessionId);
					localStorage.setItem("sessionId", sessionId);
					localStorage.setItem('refreshToken', refreshToken);
					localStorage.setItem('accessToken', accessToken);
					localStorage.setItem("user", JSON.stringify(user));
					storeAuthData(response?.payload);
					dispatch(setLoggedUserDetails(response?.payload));
					dispatch(setBotWaitLoader(true));
					dispatch(setInializeSocket(true));
					dispatch(setClearCacheForSpinnetBot(true));
					dispatch(setDomainState(true));
					navigate("/app/chats", { replace: true });
					setOtp('');
					setPassword('');
					await dispatch(fetchWalletBalanceService());
				}
			} else {
				showToast("error", res.error);
				setIsLoading(false);
			}
		});
	};


	const handleResend = async () => {
		const params = { email: emailN, appType };
		setResendLoading(true);
		setOtpError('');

		if (forgotPasswordOtp) {
			try {
				const response = await UserServiceClientApi.resetPassword(params);
				if (response?.payload && response?.payload?.success) {
					showToast("success", "OTP has been resent successfully.");
					setOtp('');
				} else {
					showToast("error", response?.error || "Something went wrong.");
				}
			} catch (error) {
				showToast("error", error.error || "An error occurred.");
			} finally {
				setResendLoading(false);
				setOtpError('');
			}
		}
		else {
			try {
				const response = await UserServiceClientApi.resendOtp(params);
				if (response?.payload && response?.payload?.success) {
					showToast("success", "OTP has been resent successfully.");
					setOtp('');
				} else {
					showToast("error", response?.error || "Something went wrong.");
				}
			} catch (error) {
				showToast("error", error || "An error occurred.");
			} finally {
				setResendLoading(false);
				setOtpError('');
			}
		}
	};

	useEffect(() => {
		const handleEnterKey = (e) => {
			if (e.key === "Enter") {
				handleVerifyCode();
			}
		};

		window.addEventListener("keydown", handleEnterKey);
		return () => window.removeEventListener("keydown", handleEnterKey);
	}, [password, otp]);

	useEffect(() => {
		const config = getDomainConfig();
		setLogoImage(config.logo);
	}, [])

	return (
		<>
			<div className="sm:col-span-6 col-span-12 3xl:py-[60px] lg:px-[60px] lg:py-[20px] px-[10px] py-[30px] h-full">
				<div className="flex flex-col h-full justify-between max-w-[491px] w-full !mx-auto">
					{logoImage &&
						<img
							className="mx-auto 3xl:w-[210px] lg:w-[180px] w-[140px]"
							src={logoImage}
							alt="Onship logo"
						/>}
					<div>
						<div className="text-center mb-5 pr-5 pl-5">
							<h1 className="lg:text-size-30 text-size-20 text-black font-semibold text-center lg:mb-[20px] mb-[6px] ">
								{forgotPasswordOtp ? "Reset your password" : "Enter Verification Code"}
							</h1>
							<p className="pl-6 pr-6 text-size-14">
								Please enter the 6 digit code we sent to your given email address {" "}
								{emailN ? `${emailN.slice(0, 3)}***@${emailN.split("@")[1]}` : ""}.
							</p>
						</div>
						<div className="space-y-[20px] ">
							<Card>
								<div className="space-y-2 relative mb-8">
									<OtpInputComponent
										setOtp={handleOtpChange}
										otp={otp}
										otpError={otpError}
									/>
								</div>
								{forgotPasswordOtp && <div className="space-y-2 relative mb-8">
									<Label
										htmlFor="name"
									>
										Password
									</Label>
									<Input
										type={showPassword ? "text" : "password"}
										name="new-password"
                                        autoComplete="new-password"
										showPassword={showPassword}
										setShowPassword={setShowPassword}
										placeholder="Please enter your Password"
										value={password}
										onChange={handleChange}
										inputError={passwordError}
										onFocus={() => setShowToolTip(true)}
										onBlur={() => setShowToolTip(false)}
									/>
									{passwordError && (
										<p className="text-red text-size-10 font-regular mt-1">{passwordError}</p>
									)}
									{showToolTip && (
										<CustomToolTip>
											<p style={{ fontSize: "13px" }}>Password must contain:</p>
											<ul style={{ padding: "5px", listStyle: "none", margin: 0 }}>
												{passwordCriteria.map((criterion, index) => (
													<li
														key={index}
													 style={{
															display: "flex",
															alignItems: "center",
															gap: "6px",
															fontSize: "13px",
															color: criterion.isDone ? "green" : "inherit",
														}}
													>
														{criterion.isDone ? (
															<span style={{ color: "green",fontSize: "13px", }}>✔</span>
														) : (
															<span style={{ width: "14px",fontSize: "13px", }}>•</span>
														)}

														{criterion.text}
													</li>
												))}
											</ul>
										</CustomToolTip>
									)}
								</div>}
								<Button className="text-white" onClick={() => handleVerifyCode()}>
									Verify
								</Button>
								<div className="text-gray-300 text-size-14 font-regular text-center mt-8">
									<div
										className="text-blue text-size-14 font-medium cursor-pointer"
										onClick={() => handleResend()}
									>
										{resendLoading ? "Sending..." : "Review email address & send the code again"}
									</div>
								</div>
							</Card>
						</div>
					</div>
					<img
						className="mx-auto w-full max-w-[260px] 3xl:mt-[80px] lg:w-[231px] mt-[0] mb-6px"
						src={ImagePath.poweredText}
						alt="Onship || Images(svg, jpg, png"
					/>
				</div>
			</div>
			{isLoading && <LoadingModal />}
		</>
	);
};

export default OtpVerify;
